import { WebAuth } from 'auth0-js';
import { env } from '$env/dynamic/public';
import { Auth0ConnectionEnum } from '$lib/helpers/auth0Helpers';

export async function login(email, password, redirectUri) {
  return new Promise((resolve) => {
    const auth0 = new WebAuth({
      domain: env.PUBLIC_AUTH0_DOMAIN!,
      clientID: env.PUBLIC_AUTH0_CLIENT_ID!,
      redirectUri: redirectUri,
      responseType: 'code',
      scope: 'openid',
    });

    auth0.client.login(
      {
        realm: Auth0ConnectionEnum.UsernamePassword,
        username: email,
        password: password,
      },
      function (err, authResult) {
        if (err) {
          resolve(err);
        } else {
          resolve(authResult);
        }
      },
    );
  });
}
